import { graphql } from "react-relay"

export const chVerifyMedicationMutation = graphql`
  mutation chVerifyMedicationMutation($input: Ch_verifyMedicationInput!) {
    ch_verifyMedication(input: $input) {
      medicationVerification {
        id
        ...MedicationVerificationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
